// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__YCycB","rootSmall":"AddTileButton_rootSmall__3nEaI"};